var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDockerSkill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22h10v10H18V22Z",
    stroke: "#FFF",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22h10v10H28V22Z",
    stroke: "#FFF",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22h10v10H38V22Z",
    stroke: "#FFF",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12h10v10H23V12Z",
    stroke: "#FFF",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36h36c0 8-6.5 16-18 16S14 44 14 36Z",
    stroke: "#FFF",
    strokeWidth: 2.8,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36c2.5 0 5-2 6-4.5-3.5-1-7 .3-8.5 2.5",
    stroke: "#FFF",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockerSkill);
export default __webpack_public_path__ + "static/media/docker-skill.e33b2692a58a1ef0b317c0c4de435c81.svg";
export { ForwardRef as ReactComponent };